import script from "./TOTPView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TOTPView.vue?vue&type=script&setup=true&lang=ts"

import "./TOTPView.vue?vue&type=style&index=0&id=3d2506cd&lang=css"

const __exports__ = script;

export default __exports__